<template>
	<div
		class="background"
		v-bind:style="{
			backgroundImage:
				!this.$route.path.includes('/login') &&
				!this.$route.path.includes('/signup') &&
				!this.$route.path.includes('/resetpassword')
					? ''
					: 'url(' + background + ')',
			height: !isAuth ? '100vh' : 'auto'
		}"
	>
		<loading-screen />

		<el-container style="display: block; overflow-y: hidden">
			<app-header v-if="isAuth && user.organization" />
			<!-- <app-header-public v-if="!isAuth"></app-header-public> -->
			<el-main
				v-if="!isAuth || user.organization"
				style="overflow-y: hidden"
				:style="{ padding: !isAuth ? '0' : '20px' }"
			>
				<div :style="{ 'overflow-y': !isAuth ? 'scroll !important' : 'hidden' }">
					<router-view />
				</div>
			</el-main>
		</el-container>
	</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import { goto } from "@/utils/utils"
import Menu from "./layout-components/Menu"
import Header from "./layout-components/Header"

import LoadingScreen from "@/modules/_common/loading-screen"
import moment from "moment"

import background from "@/assets/background.jpg"
// import AppHeaderPublic from "@/modules/public/component/app-header-public"

export default {
	name: "Layout",
	components: {
		// AppHeaderPublic,
		LoadingScreen,
		"app-header": Header,
		"app-menu": Menu
	},
	data() {
		return {
			background
		}
	},
	computed: {
		...mapGetters({
			user: "user/user",
			loaded: "user/loaded",
			isAuth: "user/logged",
			isLoading: "modules/loading"
		})
	},
	watch: {
		$route: function () {
			if (this.$route.name == "login" && !this.$route.params.auth) this.doReset()
		},
		isAuth: function () {
			if (this.isAuth) this.getOrgSubscriptions()
		}
	},
	created() {},
	methods: {
		goto,
		...mapActions({
			doReset: "user/doReset",
			getOrgSubscriptions: "organization/organizationSubscription"
		})
	}
}
</script>

<style scoped>
.background {
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;
	height: 100vh;
	overflow-y: hidden;
}
</style>
